import Phaser from 'phaser';
import { isMobile } from 'react-device-detect';


const inputFieldIdName = 'inputFieldTextEditor';
const keyboardX = 0;
const keyboardY = 0;
const keyboardW = 976;
const keyboardH = 372;
const textFieldX = keyboardX + 16;
const textFieldY = keyboardY + 16;
const textFieldW = keyboardW - 74 - 32 ; // 2 x 16 pixel
const textFieldH = 60; // same as keys height

const keyboard = [
    {name: 'keyClose', label: '✗\nkapat', labelShift:'✗\nkapat', labelNum: '✗\nkapat', x: 900, y: 16, w: 60, h: 60, bgcolor: 0xFF6666, fontsize: 18},


    {name: 'keyQ', label: 'q', labelShift:'Q', labelNum: '1', x: 16, y: 92, w: 60, h: 60},
    {name: 'keyW', label: 'w', labelShift:'W', labelNum: '2', x: 84, y: 92, w: 60, h: 60},
    {name: 'keyE', label: 'e', labelShift:'E', labelNum: '3', x: 152, y: 92, w: 60, h: 60},
    {name: 'keyR', label: 'r', labelShift:'R', labelNum: '4', x: 220, y: 92, w: 60, h: 60},
    {name: 'keyT', label: 't', labelShift:'T', labelNum: '5', x: 288, y: 92, w: 60, h: 60},
    {name: 'keyY', label: 'y', labelShift:'Y', labelNum: '6', x: 356, y: 92, w: 60, h: 60},
    {name: 'keyU', label: 'u', labelShift:'U', labelNum: '7', x: 424, y: 92, w: 60, h: 60},
    {name: 'keyI', label: 'ı', labelShift:'I', labelNum: '8', x: 492, y: 92, w: 60, h: 60},
    {name: 'keyO', label: 'o', labelShift:'O', labelNum: '9', x: 560, y: 92, w: 60, h: 60},
    {name: 'keyP', label: 'p', labelShift:'P', labelNum: '0', x: 628, y: 92, w: 60, h: 60},
    {name: 'keyĞ', label: 'ğ', labelShift:'Ğ', labelNum: '(', x: 696, y: 92, w: 60, h: 60},
    {name: 'keyÜ', label: 'ü', labelShift:'Ü', labelNum: ')', x: 764, y: 92, w: 60, h: 60},
    {name: 'keyBackSpace', label: '← sil', labelShift:'← sil', labelNum: '← sil', x: 832, y: 92, w: 128, h: 60, bgcolor: 0xFFBBBB, fontsize: 20},

    {name: 'keyA', label: 'a', labelShift:'A', labelNum: '@', x: 50, y: 160, w: 60, h: 60},
    {name: 'keyS', label: 's', labelShift:'S', labelNum: '#', x: 118, y: 160, w: 60, h: 60},
    {name: 'keyD', label: 'd', labelShift:'D', labelNum: '=', x: 186, y: 160, w: 60, h: 60},
    {name: 'keyF', label: 'f', labelShift:'F', labelNum: '*', x: 254, y: 160, w: 60, h: 60},
    {name: 'keyG', label: 'g', labelShift:'G', labelNum: '/', x: 322, y: 160, w: 60, h: 60},
    {name: 'keyH', label: 'h', labelShift:'H', labelNum: '+', x: 390, y: 160, w: 60, h: 60},
    {name: 'keyJ', label: 'j', labelShift:'J', labelNum: '-', x: 458, y: 160, w: 60, h: 60},
    {name: 'keyK', label: 'k', labelShift:'K', labelNum: '{', x: 526, y: 160, w: 60, h: 60},
    {name: 'keyL', label: 'l', labelShift:'L', labelNum: '}', x: 594, y: 160, w: 60, h: 60},
    {name: 'keyŞ', label: 'ş', labelShift:'Ş', labelNum: '[', x: 662, y: 160, w: 60, h: 60},
    {name: 'keyİ', label: 'i', labelShift:'İ', labelNum: ']', x: 730, y: 160, w: 60, h: 60},
    {name: 'keyComma', label: ',', labelShift:',', labelNum: ',', x: 798, y: 160, w: 60, h: 60},
    {name: 'keyEnter', label: '↲ giriş', labelShift:'↲ giriş', labelNum: '↲ giriş', x: 866, y: 160, w: 98, h: 60, bgcolor: 0xBBFFBB, fontsize: 20, polygonpath: '0 2 1 1 2 0 92 0 93 1 94 2 94 126 93 127 92 128 36 128 35 127 34 126 34 62 33 61 32 60 2 60 1 59 0 58 0 2'},

    {name: 'keyShift', label: '⌂ üst', labelShift:'⌂ÜST', labelNum: '⌂ üst', x: 16, y: 228, w: 60, h: 60, bgcolor: 0xBBBBFF, fontsize: 20},
    {name: 'keyZ', label: 'z', labelShift:'Z', labelNum: '<', x: 84, y: 228, w: 60, h: 60},
    {name: 'keyX', label: 'x', labelShift:'X', labelNum: '>', x: 152, y: 228, w: 60, h: 60},
    {name: 'keyC', label: 'c', labelShift:'C', labelNum: '|', x: 220, y: 228, w: 60, h: 60},
    {name: 'keyV', label: 'v', labelShift:'V', labelNum: '€', x: 288, y: 228, w: 60, h: 60},
    {name: 'keyB', label: 'b', labelShift:'B', labelNum: '$', x: 356, y: 228, w: 60, h: 60},
    {name: 'keyN', label: 'n', labelShift:'N', labelNum: '₺', x: 424, y: 228, w: 60, h: 60},
    {name: 'keyM', label: 'm', labelShift:'M', labelNum: '£', x: 492, y: 228, w: 60, h: 60},
    {name: 'keyÖ', label: 'ö', labelShift:'Ö', labelNum: ':', x: 560, y: 228, w: 60, h: 60},
    {name: 'keyÇ', label: 'ç', labelShift:'Ç', labelNum: ';', x: 628, y: 228, w: 60, h: 60},
    {name: 'keyFullStop', label: '.', labelShift:'.', labelNum: '.', x: 696, y: 228, w: 60, h: 60},
    {name: 'keyQuestionMark', label: '?', labelShift:'?', labelNum: '?', x: 764, y: 228, w: 60, h: 60},
    {name: 'keyExclamationMark', label: '!', labelShift:'!', labelNum: '!', x: 832, y: 228, w: 60, h: 60},


    {name: 'keySwitchNum', label: '123', labelShift:'123', labelNum: 'abc', x: 16, y: 296, w: 60, h: 60, bgcolor: 0xFFFFBB, fontsize: 20},
    {name: 'keyQuote', label: '\'', labelShift:'\'', labelNum: '\'', x: 84, y: 296, w: 60, h: 60},
    {name: 'keyDoubleQuote', label: '"', labelShift:'"', labelNum: '"', x: 152, y: 296, w: 60, h: 60},
    {name: 'keyDash', label: '-', labelShift:'-', labelNum: '-', x: 220, y: 296, w: 60, h: 60},
    {name: 'keySpaceBar', label: ' ', labelShift:' ', labelNum: ' ', x: 288, y: 296, w: 400, h: 60},
    {name: 'keyDollar', label: '_', labelShift:'_', labelNum: '_', x: 696, y: 296, w: 60, h: 60},
    {name: 'keyLira', label: '/', labelShift:'/', labelNum: '/', x: 764, y: 296, w: 60, h: 60},
    {name: 'keyPound', label: '#', labelShift:'#', labelNum: '#', x: 832, y: 296, w: 60, h: 60},
    {name: 'keyPercent', label: '%', labelShift:'%', labelNum: '%', x: 900, y: 296, w: 60, h: 60},

]

class VirtualKeyboardScene extends Phaser.Scene {
    constructor(param) {
        super('VirtualKeyboardScene');
        this.config = param.config;
        this.initialValue = param.initialValue;
        this.exerciseDM = param.exerciseDM;
        this.buttonDM = param.buttonDM;
        this.inputSubmitHandler = param.inputSubmitHandler;
        this.imageVendor = null;
        this.inputfield = null;
        this.keyboardBackground = null;
        this.textInputRectangle = null;
        this.isShiftPressed = false;
        this.isNumPressed = false;
        this.keyboardContainer = null;
        this.currentScale = 1;
        this.currentWidth = 0;
        this.currentHeight = 0;
        this.formFactor = 1;
        this.openingTween = null;
        this.closingTween = null;
        this.submitTween = null;
        this.resizeDisabled = false;
    }

    preload() {
        console.log('VirtualKeyboardScene preload is called');

        this.events.addListener('shutdown', this.shutdownScene, this);


        this.currentWidth = this.sys.game.canvas.width;
        this.currentHeight = this.sys.game.canvas.height;


        if (isMobile) {
            this.formFactor = 1.5;
        }

        this.currentScale = this.formFactor * (this.currentHeight / 1080);

        this.keyboardContainer = this.add.container((this.currentWidth - this.currentScale * keyboardW) / 2, 
                                                    this.currentHeight + 10);
        this.keyboardContainer.setScale(this.currentScale);

        this.keyboardBackground = this.add.graphics();
        this.keyboardBackground.fillStyle(0x8E8E8E, 1);
        this.keyboardBackground.fillRoundedRect(keyboardX, keyboardY, keyboardW, keyboardH, 10);
        this.keyboardBackground.strokeRoundedRect(keyboardX, keyboardY, keyboardW, keyboardH, 10);
        this.keyboardBackground.setInteractive(new Phaser.Geom.Rectangle(keyboardX, keyboardY, keyboardW, keyboardH), Phaser.Geom.Rectangle.Contains);
        this.keyboardBackground.on('pointerdown', (ev) => {
            ev.event.stopPropagation();
        }, this);

        this.keyboardContainer.add(this.keyboardBackground);

        this.textInputRectangle = this.add.graphics();
        this.textInputRectangle.fillStyle(0XFFFFFF, 1);
        this.textInputRectangle.fillRoundedRect(textFieldX, textFieldY, textFieldW, textFieldH, 3);
        this.textInputRectangle.strokeRoundedRect(textFieldX, textFieldY, textFieldW, textFieldH, 3);

        this.keyboardContainer.add(this.textInputRectangle );

        keyboard.forEach(key => {

            let bgcolor = 0xEEEEEE;
            if (key.bgcolor !== undefined) {
                bgcolor = key.bgcolor;
            }

            if (key.polygonpath === undefined) {
                // draw key
                let graphics = this.add.graphics();
                
                graphics.fillStyle(bgcolor, 1);
                graphics.fillRoundedRect(keyboardX + key.x, keyboardY + key.y, key.w, key.h, 3);
                graphics.strokeRoundedRect(keyboardX + key.x, keyboardY + key.y, key.w, key.h, 3);
                this.keyboardContainer.add(graphics);


                graphics.setInteractive(new Phaser.Geom.Rectangle(keyboardX + key.x, keyboardY + key.y, key.w, key.h), Phaser.Geom.Rectangle.Contains);

                graphics.on('pointerdown', () => {
                    graphics.fillStyle(0xFFFFFF, 1);
                    graphics.fillRoundedRect(keyboardX + key.x, keyboardY + key.y, key.w, key.h, 3);
                    graphics.strokeRoundedRect(keyboardX + key.x, keyboardY + key.y, key.w, key.h, 3);
                }, this);

                graphics.on('pointerout', () => {
                    graphics.fillStyle(bgcolor, 1);
                    graphics.fillRoundedRect(keyboardX + key.x, keyboardY + key.y, key.w, key.h, 3);
                    graphics.strokeRoundedRect(keyboardX + key.x, keyboardY + key.y, key.w, key.h, 3);
                }, this);

                graphics.on('pointerup', () => {
                    graphics.fillStyle(bgcolor, 1);
                    graphics.fillRoundedRect(keyboardX + key.x, keyboardY + key.y, key.w, key.h, 3);
                    graphics.strokeRoundedRect(keyboardX + key.x, keyboardY + key.y, key.w, key.h, 3);

                    if (this.inputfield === null) {
                        return;
                    }
                    
                    let inputfield = this.inputfield.getChildByID(inputFieldIdName);

                    if (key.name === 'keyBackSpace') {
                        inputfield.value = inputfield.value.substring(0, inputfield.value.length - 1);
                    } else if (key.name === 'keyShift') {
                        this.isShiftPressed = !this.isShiftPressed;
                        this.isNumPressed = false;

                        keyboard.forEach(keyItem => {
                            let keyTextValue = keyItem.label;
                            if (this.isShiftPressed) {
                                keyTextValue = keyItem.labelShift;
                            } else if (this.isNumPressed) {
                                keyTextValue = keyItem.labelNum;
                            }

                            keyItem.text.setText(keyTextValue);
                        });

                    } else if (key.name === 'keySwitchNum') {
                        this.isNumPressed = !this.isNumPressed;
                        this.isShiftPressed = false;
                        
                        keyboard.forEach(keyItem => {
                            let keyTextValue = keyItem.label;
                            if (this.isShiftPressed) {
                                keyTextValue = keyItem.labelShift;
                            } else if (this.isNumPressed) {
                                keyTextValue = keyItem.labelNum;
                            }

                            keyItem.text.setText(keyTextValue);
                        });
                    } else if (key.name === 'keyClose') {

                        if (this.closingTween === null) {
                            this.closingTween = this.tweens.add({
                                targets: this.keyboardContainer,
                                ease: 'Power1',
                                y: this.currentHeight + 10,
                                duration: 500,
                                repeat: 0,
                                onStart: () => this.resizeDisabled = true,
                                onComplete: () =>  { this.resizeDisabled = false; this.scene.stop(this)}
                            });
                        } else {
                            this.closingTween.restart();
                        }
                        
                    } else {
                        let keyTextValue = key.label;
                        if (this.isShiftPressed) {
                            keyTextValue = key.labelShift;
                        } else if (this.isNumPressed) {
                            keyTextValue = key.labelNum;
                        }

                        inputfield.value += keyTextValue;
                    }

                }, this);


                key.rectangle = graphics;

            } else {
                let polygon = this.add.polygon(keyboardX + key.x, keyboardY + key.y, key.polygonpath, bgcolor, 1).setOrigin(0);
                polygon.strokeColor = 0x000000;
                polygon.isStroked = true;
                this.keyboardContainer.add(polygon);


                polygon.setInteractive(new Phaser.Geom.Polygon(key.polygonpath), Phaser.Geom.Polygon.Contains);

                polygon.on('pointerdown', () => {
                    polygon.setFillStyle(0xFFFFFF, 1);

                    let inputfield = this.inputfield.getChildByID(inputFieldIdName);
                    this.inputSubmitHandler(this.exerciseDM, this.buttonDM, inputfield.value);
                    if (this.submitTween === null) {
                        this.submitTween = this.tweens.add({
                            targets: this.keyboardContainer,
                            ease: 'Power1',
                            y: this.currentHeight + 10,
                            duration: 500,
                            repeat: 0,
                            onComplete: () => this.scene.stop(this)
                        });
                    } else {
                        this.submitTween.restart();
                    }
                });

                polygon.on('pointerup', () => {
                    polygon.setFillStyle(bgcolor, 1);
                });

                polygon.on('pointerout', () => {
                    polygon.setFillStyle(bgcolor, 1);
                });

                key.polygon = polygon;
            }


            // draw label
            let keyTextValue = key.label;
            if (this.isShiftPressed) {
                keyTextValue = key.labelShift;
            } else if (this.isNumPressed) {
                keyTextValue = key.labelNum;
            }

            let fontsize = 28;
            if (key.fontsize !== undefined) {
                fontsize = key.fontsize;
            }

            key.text = this.add.text(keyboardX + key.x + key.w / 2, keyboardY + key.y + key.h / 2, keyTextValue, {align: 'center', font: `${fontsize}px arial`, color: '#000000'});
            key.text.setOrigin(0.5);
            this.keyboardContainer.add(key.text);

            if (key.icon !== undefined) {
                this.load.image(key.icon, key.icon);
            }
        });

        this.cameras.main.zoom = 1;


    }


    create() {
        console.log('VirtualKeyboardScene create is called');


        keyboard.forEach(key => {
            if (key.icon !== undefined) {
                key.image = this.add.image(keyboardX + key.x + key.w / 2, keyboardY + key.y + key.h / 2, key.icon);
            }
        });

        this.inputfield = this.add.dom().createFromHTML(`<input type="text" id="${inputFieldIdName}" inputmode="none" style="border-radius: 3px; font-size: 28px; color: black; width: ${textFieldW}px; height: ${textFieldH}px;">`).setOrigin(0);
        this.inputfield.id = inputFieldIdName;
        let inputfield = this.inputfield.getChildByID(inputFieldIdName);
        inputfield.value = this.initialValue; // default value is added here
        inputfield.focus();


        inputfield.addEventListener('keypress', (event) => {
            if (event.key !== 'Enter') {
                return;
            }

            let inputfield = this.inputfield.getChildByID(inputFieldIdName);
            this.inputSubmitHandler(this.exerciseDM, this.buttonDM, inputfield.value);
            if (this.submitTween === null) {
                this.submitTween = this.tweens.add({
                    targets: this.keyboardContainer,
                    ease: 'Power1',
                    y: this.currentHeight + 10,
                    duration: 500,
                    repeat: 0,
                    onComplete: () => this.scene.stop(this)
                });
            } else {
                this.submitTween.restart();
            }
        });

        this.inputfield.setX(textFieldX);
        this.inputfield.setY(textFieldY);
        this.inputfield.setW(textFieldW);
        this.inputfield.setW(textFieldH);


        this.keyboardContainer.add(this.inputfield);


        this.openingTween = this.tweens.add({
            targets: this.keyboardContainer,
            ease: 'Power1',
            y: this.currentHeight - this.currentScale * keyboardH,
            duration: 500,
            repeat: 0,
            onStart: () => this.resizeDisabled = true,
            onComplete: () => this.resizeDisabled = false
        });
    }

    update() {
        let {width, height} = this.sys.game.canvas;
        if (!this.resizeDisabled && (this.currentWidth !== width || this.currentHeight !== height)) {
            this.currentWidth = width;
            this.currentHeight = height;
            this.currentScale = this.formFactor * (this.currentHeight / 1080);
            
            this.keyboardContainer.setX((this.currentWidth - this.currentScale * keyboardW) / 2);
            this.keyboardContainer.setY(this.currentHeight - this.currentScale * keyboardH);
            this.keyboardContainer.setScale(this.currentScale);
        }
    }

    shutdownScene() {
        console.log('VirtualKeyboardScene shutdown is called, unregister listeners');
    }


}

export default VirtualKeyboardScene;